


























import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, elementWidth } from '@/mixins'
import easyapi from '@/easyapi'
import { deepCopy } from '@/utils'
import VwResizePreview from '@/components/VwResizePreview.vue'
import { VW_MAX_COLUMNS, VW_MAX_ROWS } from '@/vw_algorithm'

export default mixins(vwDialogMixin, elementWidth).extend({
  components: {
    VwResizePreview
  },
  data (): {
    newName: string,
    columns: number,
    rows: number,
  } {
    return {
      newName: '',
      columns: 2,
      rows: 2,
    }
  },
  computed: {
    vw (): IVW | null { return this.dialog.vw }
  },
  methods: {
    addCol (x: number) {
      const tmp = this.columns + x
      if (tmp > VW_MAX_COLUMNS) { this.columns = VW_MAX_COLUMNS; return }
      if (tmp < 1) { this.columns = 1; return }
      this.columns = tmp
    },
    addRow (x: number) {
      const tmp = this.rows + x
      if (tmp > VW_MAX_ROWS) { this.rows = VW_MAX_ROWS; return }
      if (tmp < 1) { this.rows = 1; return }
      this.rows = tmp
    },
    async apply () {
      if (!this.vw) { return }
      const cpVw = deepCopy(this.vw)
      cpVw.layout.columns = this.columns
      cpVw.layout.rows = this.rows
      cpVw.rxList.length = 0
      const ok = await easyapi.modifyVw(cpVw)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  watch: {
    vw (vw: IVW | null) {
      if (vw) {
        this.columns = vw.layout.columns
        this.rows = vw.layout.rows
      }
    }
  },
  mounted () {
    this.watchElementWidth('card', ['vw'])
  }
})
